import { render, staticRenderFns } from "./Pager.vue?vue&type=template&id=116ab4a6&scoped=true&"
import script from "./Pager.vue?vue&type=script&lang=js&"
export * from "./Pager.vue?vue&type=script&lang=js&"
import style0 from "./Pager.vue?vue&type=style&index=0&id=116ab4a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116ab4a6",
  null
  
)

export default component.exports